
import React, { useState } from 'react';
import { glossaryTerms, glossaryCategories } from '../../../mocks/glossary';

export const GlossarySection: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedTerm, setExpandedTerm] = useState<number | null>(null);

  const filteredTerms = glossaryTerms.filter(term => {
    const matchesCategory = activeCategory === 'all' || term.category === activeCategory;
    const matchesSearch = term.term.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         term.definition.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-700 rounded-full text-sm font-medium mb-4">
            Глоссарий
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Термины <span className="text-emerald-600">мобильных казино онлайн</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Полный словарь терминов для понимания мира онлайн казино
          </p>
        </div>

        <div className="mb-8">
          <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
            <div className="relative w-full md:w-80">
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
              <input
                type="text"
                placeholder="Поиск термина..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-11 pr-4 py-3 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
              />
            </div>
            <div className="flex flex-wrap gap-2 justify-center">
              {glossaryCategories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setActiveCategory(category.id)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                    activeCategory === category.id
                      ? 'bg-emerald-600 text-white'
                      : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {filteredTerms.map((term) => (
            <div
              key={term.id}
              className={`bg-gray-50 rounded-xl overflow-hidden transition-all duration-300 ${
                expandedTerm === term.id ? 'ring-2 ring-emerald-300' : ''
              }`}
            >
              <button
                onClick={() => setExpandedTerm(expandedTerm === term.id ? null : term.id)}
                className="w-full p-5 text-left flex items-center justify-between cursor-pointer"
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-book-open-line text-emerald-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">{term.term}</h3>
                    <span className="text-xs text-emerald-600 bg-emerald-50 px-2 py-0.5 rounded-full">
                      {term.category}
                    </span>
                  </div>
                </div>
                <i className={`ri-arrow-down-s-line text-xl text-gray-400 transition-transform duration-300 ${
                  expandedTerm === term.id ? 'rotate-180' : ''
                }`}></i>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${
                expandedTerm === term.id ? 'max-h-40' : 'max-h-0'
              }`}>
                <div className="px-5 pb-5 pt-0">
                  <p className="text-gray-600 text-sm leading-relaxed">{term.definition}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredTerms.length === 0 && (
          <div className="text-center py-12">
            <i className="ri-search-eye-line text-4xl text-gray-300 mb-4"></i>
            <p className="text-gray-500">Термины не найдены. Попробуйте изменить поиск.</p>
          </div>
        )}
      </div>
    </section>
  );
};
